export const WIDGET_HOST_CHANGED_EVENT = 'fusion:widget-host-changed';

export const notifyWidgetHostChanged = (hostElement) => {
  const runtimeWindow = hostElement?.ownerDocument?.defaultView;
  const CustomEventConstructor = runtimeWindow?.CustomEvent;

  if (!hostElement || typeof CustomEventConstructor !== 'function') return;

  const eventTargets = [hostElement, ...hostElement.querySelectorAll('[data-widget-host-aware]')];

  eventTargets.forEach((eventTarget) => {
    eventTarget.dispatchEvent(
      new CustomEventConstructor(WIDGET_HOST_CHANGED_EVENT, {
        detail: {
          runtimeWindow,
        },
      }),
    );
  });
};
